import React, { useEffect, useState } from "react";
import { postCall } from "./../utils/Network";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import countries from "../utils/countries_states.json";
// import './home.scss';
import { useSelector } from "react-redux";
import "./css/addCardForm.css";
import { FaLock } from "react-icons/fa";
import { IconShieldHalf } from "@tabler/icons-react";
import { Box, MenuItem, Select } from "@mui/material";
import { flagEnabled } from "../utils/flag";

const ChevronDownIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#6f6f70"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icon-tabler-chevron-down"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M6 9l6 6l6 -6" />
  </svg>
);

// Add Card Form Component

const AddCardForm = ({
  associateId,
  customerDetails,
  email,
  fnCardForm,
  getPayment,
  bearerToken = "",
}) => {
  //component to add the card for doing payments

  const { t } = useTranslation();
  // const token = useSelector((state) => state.signup.token);
  const token = sessionStorage.getItem("token");

  // let associatejson = localStorage.getItem('associateData');

  // let associateData = JSON.parse(associatejson);
  // console.log(email, "Json");
  // const email = associateData?.email;

  const countryOptions = countries?.data;
  const [stateOptions, setStateOptions] = useState([]);

  const [ccNumber, setccNumber] = useState("");
  const [cvv, setCvv] = useState("");
  const [cvvError, setCvvError] = useState("");
  // const [ccExp, setccExp] = useState('');
  // const [ccExpMonth, setccExpMonth] = useState('')
  // const [ccExpYear, setccExpYear] = useState('')
  // const [ccExpMonthError, setccExpMonthError] = useState('');
  // const [ccExpYearError, setccExpYearError] = useState('');
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [country, setCountry] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneCode, setPhoneCode] = useState();
  const [ccYear, setccYear] = useState("");
  const [ccMonth, setccMonth] = useState("");
  const [ccExp, setccExp] = useState("");

  const [ccNumberError, setccNumberError] = useState("");
  const [ccExpError, setccExpError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [address1Error, setAddress1Error] = useState("");
  // const [address2Error, setAddress2Error] = useState('');
  const [cityError, setCityError] = useState("");
  const [stateError, setStateError] = useState("");
  const [zipError, setZipError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  // const [vaultId, setVaultId] = useState("")
  // const [last4, setLast4] = useState('')

  // const formatExpirationDate = () => {
  //     const year = parseInt(ccExpYear)
  //     const month = parseInt(ccExpMonth)
  //     const expirationData = new Date(year, month - 1, 1)
  //     return expirationData.toISOString()
  // }

  const addPayment = async () => {
    let data = {
      url: "nmiTokenize",
      bodyData: {
        associateId: associateId,
        cCnumber: ccNumber,
        cCexpirationDate: ccExp,
        firstName: firstName,
        lastName: lastName,
        line1: address1,
        line2: address2,
        state: state,
        city: city,
        zip: zip,
        countryCode: country,
        phone: `${phoneCode}${phone}`,
        email: email,
        cvv: cvv,
      },
      header: { Authorization: "Bearer " + token },
    };
    const response = await postCall(data);
    if (response?.status === 200) {
      // Handle success
      getPayment(); // refresh payment details
    }
  };

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  //  Country function
  const fnCountry = (e) => {
    setCountry(e.target.value);

    setState("");
    countryOptions.map((item) => {
      if (item.iso2 == e.target.value) {
        setStateOptions(item.states);
        setPhoneCode(item.phoneCode);
      }
    });
  };

  useEffect(() => {
    if (customerDetails?.billingAddress?.countryCode) {
      setCountry(customerDetails?.billingAddress?.countryCode);
      countryOptions.map((item) => {
        if (item?.iso2 == customerDetails?.billingAddress?.countryCode) {
          setStateOptions(item?.states);
        }
      });
    }
    if (customerDetails?.phoneCode) {
      setPhoneCode(customerDetails?.phoneCode)
    }
  }, [customerDetails]);

  // add to cart function
  const fnAddCart = async (e) => {
    e?.preventDefault();
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let error = false;
    // verification of the feilds in the form
    if (email === "") {
      setEmailError(t("enterEmail"));
      error = true;
    } else {
      setEmailError("");
    }

    if (ccNumber === "") {
      setccNumberError(t("enterCardNumber"));
      error = true;
    } else if (ccNumber.length !== 16 && ccNumber.length !== 15) {
      setccNumberError(t("invalidCardNumber"));
      error = true;
    } else {
      setccNumberError("");
    }

    if (cvv === "") {
      setCvvError(t("enterCvv")); // Show error if CVV is empty
      error = true;
    } else if (cvv.length !== 3 && cvv.length !== 4) {
      setCvvError(t("invalidCvv")); // Show error if CVV length is invalid
      error = true;
    } else {
      setCvvError(""); // Clear error if CVV is valid
    }

    // if (ccExpMonth === '') {
    //     setccExpError(t('enterExpiryDate'));
    //     error = true;
    // } else if (parseInt(ccExpMonth) < 1 || parseInt(ccExpMonth) > 12) {
    //     setccExpError(t('invalidExpiryDate'));
    //     error = true;
    // } else {
    //     setccExpError('');
    // }

    // if (ccExpYear === '') {
    //     setccExpError(t('enterExpiryDate'));
    //     error = true;
    // } else if (parseInt(ccExpYear) < currentYear) {
    //     setccExpError(t('invalidExpiryDate'));
    //     error = true;
    // } else if (parseInt(ccExpYear) === currentYear && parseInt(ccExpMonth) < currentMonth) {
    //     setccExpError(t('invalidExpiryDate'));
    //     // setccExpYearError('')
    //     error = true;
    // } else {
    //     setccExpError('');
    // }

    if (firstName === "") {
      setFirstNameError(t("enterFirstName"));
      error = true;
    } else {
      setFirstNameError("");
    }

    if (lastName === "") {
      setLastNameError(t("enterLastName"));
      error = true;
    } else {
      setLastNameError("");
    }

    if (address1 === "") {
      setAddress1Error(t("enterAddress1"));
      error = true;
    } else {
      setAddress1Error("");
    }

    if (city === "") {
      setCityError(t("enterCity"));
      error = true;
    } else {
      setCityError("");
    }

    if (state === "") {
      setStateError(t("chooseState"));
      error = true;
    } else {
      setStateError("");
    }

    if (zip === "") {
      setZipError(t("enterZipcode"));
      error = true;
    } else {
      setZipError("");
    }

    if (country === "") {
      setCountryError(t("chooseCountry"));
      error = true;
    } else {
      setCountryError("");
    }

    if (phone === "") {
      setPhoneError(t("enterPhoneNumber"));
      error = true;
    } else {
      setPhoneError("");
    }
    if (error) {
      return error;
    }
    addPayment();
  };

  const fnYearChange = (y) => {
    setccYear(y);
    setccExp(y + "-" + ccMonth + "-01");
  };

  const fnMonthChange = (m) => {
    setccMonth(m);
    setccExp(ccYear + "-" + m + "-01");
  };

  const checkKeyPress = (e) => {
    if (e?.key === "Enter") {
      e?.stopPropagation();
      fnAddCart(e);
    }
  };

  return (
    <div className="pop-up flx-form home">
      <div className="popup-inp-div">
        <form className="payment-form">
          <h3 className="payment-title">{t("paymentInfo")}</h3>

          {/* CARD DETAILS */}
          <div className="payment-section">
            <div className="inp-div mb-2">
              <label className="form-label">
                {t("cardNumber")} <sup className="superScrpit">*</sup>
              </label>
              <input
                type="number"
                className="form-control"
                placeholder={t("cardNumber")}
                value={ccNumber}
                onChange={(e) => setccNumber(e.target.value?.replace(/[^\d]/gi, '')?.substring(0, 16))}
              />
              <small
                className="serr"
                style={ccNumberError ? {} : { display: "none" }}
              >
                {ccNumberError}
              </small>
            </div>

            <div className="row g-2">
              <div className="col-6">
                <label className="form-label">
                  {t("expirationDate")} <sup className="superScrpit">*</sup>
                </label>
                <div className="d-flex gap-2">
                  <select
                    className="form-select"
                    value={ccMonth}
                    onChange={(e) => fnMonthChange(e.target.value)}
                  >
                    <option value="">{t("month")}</option>
                    <option value="01">{t("jan")}</option>
                    <option value="02">{t("feb")}</option>
                    <option value="03">{t("mar")}</option>
                    <option value="04">{t("apr")}</option>
                    <option value="05">{t("may")}</option>
                    <option value="06">{t("jun")}</option>
                    <option value="07">{t("jul")}</option>
                    <option value="08">{t("aug")}</option>
                    <option value="09">{t("sep")}</option>
                    <option value="10">{t("oct")}</option>
                    <option value="11">{t("nov")}</option>
                    <option value="12">{t("dec")}</option>
                  </select>

                  <select
                    className="form-select"
                    value={ccYear}
                    onChange={(e) => fnYearChange(e.target.value)}
                  >
                    <option value="">{t("year")}</option>
                    {[...Array(16)].map((_, i) => {
                      const y = 2025 + i;
                      return (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <small
                  className="serr"
                  style={ccExpError ? {} : { display: "none" }}
                >
                  {ccExpError}
                </small>
              </div>

              <div className="col-6">
                <label className="form-label">
                  {t("CVV")} <sup className="superScrpit">*</sup>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={t("cvv")}
                  value={cvv}
                  onChange={(e) => setCvv(e.target.value)}
                />
                <small
                  className="serr"
                  style={cvvError ? {} : { display: "none" }}
                >
                  {cvvError}
                </small>
              </div>
            </div>
          </div>

          <div className="payment-section">
            <h6 className="section-title">{t("cardHolderName")}</h6>
            <label className="form-label">
              {t("firstName")}
              <sup className="superScrpit">*</sup>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder={t("firstName")}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />

            <label className="form-label">
              {t("lastName")}
              <sup className="superScrpit">*</sup>
            </label>
            <input
              type="text"
              className="form-control mb-2"
              placeholder={t("lastName")}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          {/* BILLING ADDRESS */}
          <div className="payment-section">
            <h6 className="section-title">{t("billingAddress")}</h6>

            <label className="text-start form-label">
              {t("Address")}
              <sup className="superScrpit">*</sup>
            </label>
            <input
              type="text"
              className="form-control mb-2"
              placeholder={t("Address")}
              value={address1}
              onChange={(e) => setAddress1(e.target.value)}
            />

            <div className="row g-2 mb-2 one-line">
              <div className="col-12 col-md-6 field">
                <label className="text-start form-label">
                  {t("country")}
                  <sup className="superScrpit">*</sup>
                </label>
                <div className="col-6">
                  { !flagEnabled('FIX_COUNTRY_PHONE_CODE')?<select className="form-select" onChange={fnCountry}>
                    <option>{t("selectCountry")}</option>
                    {countryOptions.map((c) => (
                      <option key={c.iso2} value={c.iso2}>
                        {c.label}
                      </option>
                    ))}
                  </select>:
                  <Select
                    value={country}
                    disabled
                    IconComponent={ChevronDownIcon}
                    // className="form-select"
                    sx={{
                      height: "60px",
                      borderRadius: "10px",
                      width: "100%",
                      borderColor: '#504f4fb7',
                      color: "#ffffff",
                      "& .MuiSelect-select": {
                        color: "#6f6f70",
                      },
                      "&.Mui-disabled .MuiSelect-select": {
                        WebkitTextFillColor: "#6f6f70",
                      },
                      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                        borderColor: "#504f4fb7",
                      },

                      // Border hover
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#504f4fb7",
                      },

                      // Border when focused
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#504f4fb7",
                      },
                      "&.Mui-disabled .MuiSelect-icon": {
                        color: '#6f6f70'
                      }
                    }}
                  >
                    {countryOptions.map((c) => (
                      <MenuItem key={c.iso2} value={c.iso2}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <img
                            src={`https://flagcdn.com/w40/${c.iso2.toLowerCase()}.png`}
                            width="20"
                            height="20"
                            style={{ borderRadius: "50%" }}
                            alt={c.iso2}
                          />
                          {c.label}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>}
                </div>
              </div>

              <div className="col-12 col-md-6 field">
                <label className="text-start form-label">
                  {t("state")}
                  <sup className="superScrpit">*</sup>
                </label>
                <div className="col-6">
                  <select
                    className="form-select"
                    onChange={(e) => setState(e.target.value)}
                  >
                    <option>{t("selectState")}</option>
                    {stateOptions?.map((s) => (
                      <option key={s.value} value={s.value}>
                        {s.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row g-2 mb-2 one-line">
              <div className="col-12 col-md-6 field">
                <label className="text-start form-label">
                  {t("city")}
                  <sup className="superScrpit">*</sup>
                </label>
                <div className="col-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("city")}
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-12 col-md-6 field">
                <label className="text-start form-label">
                  {t("zip")}
                  <sup className="superScrpit">*</sup>
                </label>
                <div className="col-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("zip")}
                    value={zip}
                    onChange={(e) => setZip(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <label className="text-start form-label">
              {t("phone")}
              <sup className="superScrpit">*</sup>
            </label>
            <div className="d-flex gap-2">
              <select
                className="form-select"
                style={{ width: "10rem" }}
                value={phoneCode}
                disabled={flagEnabled('FIX_COUNTRY_PHONE_CODE')}
                onChange={(e) => setPhoneCode(e.target.value)}
              >
                {countryOptions.map((c, i) => (
                  <option key={i} value={c.phoneCode}>
                    {c.phoneCode}
                  </option>
                ))}
              </select>
              <input
                type="number"
                className="form-control"
                placeholder={t("phone")}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </div>

          {/* FOOTER */}
          <p className="payment-footer">
            <FaLock style={{ marginRight: "0.5rem", marginTop: "0.1rem" }} />
            {t("yourPaymentInformationIsEncryptedAndSecure")}
          </p>

          <div className="bn-div">
            <div className="primary-button-wrapper">
              <a
                href="#"
                onClick={() => fnCardForm(false)}
                data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                className="primary-button w-inline-block"
              >
                <div className="primary-button-border-wrap">
                  <div className="primary-button-wrap">
                    <div className="primary-button-text">{t("cancel")}</div>
                    <div className="primary-button-hover-text">
                      {t("cancel")}
                    </div>
                    <div className="primary-button-hover-bg"></div>
                  </div>
                </div>
                <div className="line-wrap">
                  <div className="primary-line-wrap _1">
                    <div className="line _1"></div>
                    <div className="line _2"></div>
                  </div>
                  <div className="primary-line-wrap _2">
                    <div className="line _3"></div>
                    <div className="line _4"></div>
                  </div>
                  <div className="primary-line-wrap _3">
                    <div className="line _5"></div>
                    <div className="line _6"></div>
                  </div>
                  <div className="primary-line-wrap _4">
                    <div className="line _7"></div>
                    <div className="line _8"></div>
                  </div>
                </div>
              </a>
            </div>
            <div className="primary-button-wrapper">
              <a
                href="#"
                onClick={fnAddCart}
                data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                className="primary-button w-inline-block"
              >
                <div className="primary-button-border-wrap">
                  <div className="primary-button-wrap">
                    <div className="primary-button-text">{t("submit")}</div>
                    <div className="primary-button-hover-text">
                      {t("submit")}
                    </div>
                    <div className="primary-button-hover-bg"></div>
                  </div>
                </div>
                <div className="line-wrap">
                  <div className="primary-line-wrap _1">
                    <div className="line _1"></div>
                    <div className="line _2"></div>
                  </div>
                  <div className="primary-line-wrap _2">
                    <div className="line _3"></div>
                    <div className="line _4"></div>
                  </div>
                  <div className="primary-line-wrap _3">
                    <div className="line _5"></div>
                    <div className="line _6"></div>
                  </div>
                  <div className="primary-line-wrap _4">
                    <div className="line _7"></div>
                    <div className="line _8"></div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </form>

        <button className="bn-close" onClick={() => fnCardForm(false)}>
          X
        </button>
      </div>
    </div>
  );
};

AddCardForm.propTypes = {
  //props validation by using propTypes
  associateId: PropTypes.number.isRequired,
  fnCardForm: PropTypes.func.isRequired,
  getPayment: PropTypes.func.isRequired,
  bearerToken: PropTypes.string,
  email: PropTypes.string,
};

export default AddCardForm;
